/* eslint @typescript-eslint/no-explicit-any: 0 */
import { createContext, useContext } from 'react'
import { EventBusListenerType, IEventBus } from './types'

export function createEventBusHook<E extends string = string>() {
	const listeners = new Map<string, EventBusListenerType[]>()

	const getListeners = (eventName: E) => {
		const genericEventName = eventName as string
		if (!listeners.has(genericEventName)) {
			listeners.set(genericEventName, [])
		}
		return listeners.get(genericEventName) as EventBusListenerType[]
	}

	const subscribe = (eventName: E, listener: EventBusListenerType) => {
		getListeners(eventName).push(listener)
		return () => {
			const index = getListeners(eventName).indexOf(listener)
			if (index !== -1) {
				getListeners(eventName).splice(index, 1)
			}
		}
	}

	const dispatch = (eventName: E, payload?: any) => {
		getListeners(eventName).forEach(listener => listener(payload))
	}

	const Context = createContext<IEventBus<E>>({
		subscribe,
		dispatch,
	})

	return function useEventBus() {
		return useContext(Context)
	}
}
